<template>
  <div class="validation_request_order_suborders">
    <div class="validation_request_order_suborders_head_container">
      <div class="validation_request_order_suborders_head">
        <h5 >{{suborder.text}}</h5>
      </div>
      <div class="validation_request_order_suborders_head_informations">
        <ul>
          <li> Prix unitaire = {{(suborder.price / 100).toFixed(2)}} € / {{suborder.decoded_unit}}</li>
          <li> T.V.A. ({{(suborder.tax_rate * 100).toFixed(2)}}%) = {{(suborder.tax_amount / 100).toFixed(2)}} €</li>
          <li> Profile du demandeur: {{suborder.decoded_requester_profile}} </li>
          <li v-if="suborder.headquarter_transfer"> Transfert du siège social </li>
          <!-- <li v-if="suborder.domiciliation_type"> Type : {{suborder.domiciliation_type}} </li> -->
          <li v-if="suborder.contract_start_date"> Date de début du contrat : {{suborder.contract_start_date | moment-date}}</li>
          <li v-if="suborder.contract_end_date"> Date de fin du contrat : {{suborder.contract_end_date | moment-date}}</li>
          <li v-if="suborder.booking_start_date"> Date de debut de la réservation : {{suborder.booking_start_date | moment-date-time}}</li>
          <li v-if="suborder.booking_end_date"> Date de fin de la réservation : {{suborder.booking_end_date | moment-date-time}}</li>
          <li v-if="suborder.promotion_code"> Code promotionnel : {{suborder.promotion_code}}</li>
        </ul>
      </div>
    </div>
    <options :options="suborder.options">
    </options>
    <slot></slot>
  </div>
</template>
<script>
import Options from "./Options"
export default {
  name:"ValidationRequestableOrderSuborders",
  props:["suborder"],
  components:{
    Options,
  },

}
</script>
<style scoped>
.validation_request_order_suborders {
  display: flex;
  padding-left: 15px;
  padding-right: 15px;

}

.validation_request_order_suborders_head {
  border-bottom:solid 1px lightgray;
  }


.validation_request_order_suborders_head_container{
  /*width: 55%;*/
  border-right: solid 1px lightgray;
  width: -webkit-fill-available;
  padding-left: 15px;
  padding-right: 15px;
}

.validation_request_order_suborders_container {
  /*display: inline-flex;*/
  /*text-align: -webkit-center;*/
  /*padding-left: 80px;*/
  padding-left: 15px;
  padding-right: 15px;
  width: max-content;
}

.validation_request_order_suborders_options {
  margin-left: 5px;
}

@media screen and (max-width: 1200px) {

  .validation_request_order_suborders {
    display: block;
  }

  .validation_request_order_suborders_head_container {
    border-right: 0;
  }

  
}

</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Order/Suborders.vue